import React from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../../hooks/useThemedStyles';
import MarketSetupList from './MarketSetupList';
import { GET_MARKET_SETUPS } from '../../../../common/graphql/marketSetup';

const MarketSetupListView = () => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<MarketSetupList
				query={GET_MARKET_SETUPS}
				initialSortBy="dueDate"
				initialSortDirection={-1}
				initialPerPage={15}
				listId="native_market_setups"
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	container: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
});

export default MarketSetupListView;
